var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.543 2C123.878 2.00001 131.975 58.2304 131.975 58.2304L132.12 116.484H255.855V133.975H82.9723C82.9723 133.975 0 124.565 0 255.398C-9.248e-06 386.231 72.4201 381.591 72.4201 381.591H115.641V320.88C115.641 320.88 113.311 248.46 186.905 248.46H309.628C309.628 248.46 378.579 249.574 378.579 181.822V69.7945C378.579 69.7945 389.048 2 253.543 2ZM185.314 41.1733C197.625 41.1733 207.575 51.1234 207.575 63.4342C207.575 75.745 197.625 85.6951 185.314 85.6951C173.004 85.6951 163.054 75.745 163.054 63.4342C163.054 51.1234 173.004 41.1733 185.314 41.1733Z",
    fill: "url(#paint0_linear_102_1532)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.225 510.108C386.89 510.108 378.793 453.878 378.793 453.878L378.648 395.624H254.912V378.133H427.796C427.796 378.133 510.768 387.543 510.768 256.71C510.768 125.877 438.348 130.517 438.348 130.517H395.127V191.228C395.127 191.228 397.457 263.648 323.863 263.648H201.139C201.139 263.648 132.188 262.534 132.188 330.286V442.314C132.188 442.314 121.72 510.108 257.225 510.108ZM325.453 470.935C313.143 470.935 303.192 460.985 303.192 448.674C303.192 436.363 313.143 426.413 325.453 426.413C337.764 426.413 347.714 436.363 347.714 448.674C347.714 460.985 337.764 470.935 325.453 470.935Z",
    fill: "url(#paint1_linear_102_1532)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1532",
    x1: 49.0857,
    y1: 47.7029,
    x2: 302.204,
    y2: 298.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_1532",
    x1: 204.45,
    y1: 208.617,
    x2: 476.271,
    y2: 465.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.404eb732f62b5fc70d1387f1a620c11f.svg";
export { ForwardRef as ReactComponent };